import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=8460ec9a"
import script from "./Search.vue?vue&type=script&setup=true&lang=ts"
export * from "./Search.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Search.vue?vue&type=style&index=0&id=8460ec9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports